import { render, staticRenderFns } from "./addTemplateQuestion.vue?vue&type=template&id=4a5789fa&scoped=true"
import script from "./addTemplateQuestion.vue?vue&type=script&lang=js"
export * from "./addTemplateQuestion.vue?vue&type=script&lang=js"
import style0 from "./addTemplateQuestion.vue?vue&type=style&index=0&id=4a5789fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5789fa",
  null
  
)

export default component.exports